<template>
  <BlogElement
    v-for="(element,i) in computedFilteredElements"
    :key="modelBlog?.id+'_contentshowelement_'+element.type+'_'+i+'_'+element.unique+'_'+element.id"
    v-model="computedFilteredElements[i]"
    v-model:blog="modelBlog"
    :data-element-i="i"

    @remove="methodRemoveElement(modelBlog as Blog, element)"
    @moveup="methodMoveElement(modelBlog as Blog, element, true)"
    @movedown="methodMoveElement(modelBlog as Blog, element, false)"
    @addabove="methodAddElement(modelBlog as Blog, element, false)"
    @addbelow="methodAddElement(modelBlog as Blog, element, true)"
    />
</template>

<script setup lang="ts">
defineEmits([
  'elements'
])

const props = defineProps<{
  parentUnique?: string|null
}>()

const modelBlog = defineModel<Blog>('blog')
const modelElements = defineModel<BlogElement[]>('elements',{
  default: () => []
})

const computedFilteredElements = computed({
  get: () => {
    return modelElements.value.filter(e => !e.inside || props.parentUnique == e.inside);
  },
  set: (value) => {
    modelElements.value = value;
  }
})
</script>
